import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

import Tree from '../Tree/Tree';

import sAction from 'sAction';

export default class ListViewTableTree extends PureComponent {
    change(id) {
        const data = this.props.data;
        const way = this.props.way;

        let ids = [];
        sAction.getSubCatFromTree(data.tree, id, false, ids);

        if (ids.length == 0) {
            ids = null;
        }
        sAction.dataSet(way+'/listViewTree/activeCategory', id);
        if (sAction.dataGet(way + '/defaultFilter/tree/')) {
            sAction.dataSet(way + '/defaultFilter/tree/parentId', ids);
        } else {
            const tree = sAction.dataGet(way + '/listViewTree');
            sAction.dataSet(way + '/defaultFilter/tree', {
                field: tree.field,
                module: tree.module,
                name: tree.name,
                relationship: tree.relationship,
                operandType: 'relate',
                parentId: ids,
                type: 'contArray',
            }, 'filterRelationship');
        }
        sAction.reloadList(0, 1, way);
    }

    checkCategory(id, tree) {
        if (id == null || tree == null) return false;

        if (tree.id === id) return true;

        if (tree.children && tree.children.length > 0) {
            for (const child of tree.children) {
                if (this.checkCategory(id, child)) {
                    return true;
                }
            }
        }

        return false;
    }

    getDefaultCategory() {
        if (this.props.data.module !== 'aon_portal_documents') return '';

        return sAction.params.portalCompany === 'aon' ? '66174233-ab9b-c0ed-e32b-64e86e124282' : '48138115-7ac0-584b-bed8-67fd15e09ac6';
    }

    render() {
        let activeCategory = this.props.data.activeCategory;
        if (activeCategory == null) {
            activeCategory = sAction.dataGet('view/defaultFilter/tree/parentId/0');
        }

        if (!activeCategory || !this.checkCategory(activeCategory, sAction.dataGet(this.props.way + '/listViewTree/tree/0')?.toJS())) {
            const defaultCategory = this.getDefaultCategory();
            if (activeCategory !== defaultCategory) {
                activeCategory = defaultCategory;
                this.change(activeCategory);
            }
        }

        return (
            <div className="listViewTableTree">
                <Tree
                    header={sAction.translate('LBL_TREE_CATEGORY')}
                    data={this.props.data.tree.toJS()}
                    selected={activeCategory}
                    onSelectGroup={(id) => this.change(id)}
                    openLevel={1}
                    module={this.props.data.module}
                />
            </div>
        );
    }
}

ListViewTableTree.propTypes = {
    data: PropTypes.shape({
        activeCategory: PropTypes.string,
        tree: PropTypes.any,
        module: PropTypes.string,
    }),
    way: PropTypes.string,
};
